<!--
 * @Descripttion: 收藏页面问答组件
 * @Author: Niu Chenxin
 * @Date: 2021-01-14 11:15:25
 * @LastEditors: Niu Chenxin
 * @LastEditTime: 2021-01-18 10:41:18
-->
<template>
  <div class="list_item_expert">
    <van-list :class="userExpertCollect.length==0?'list_wrap':'list_wrap list_empty'" v-model="expertParams.Loading" :finished="expertParams.Finished" :finished-text="expertParams.finishText" :error.sync="expertParams.Error" error-text="请求失败，点击重新加载" @load="getExpert">
      <div class="list_item" v-for="item in userExpertCollect" :key="item.id" @click.stop="gioClick(item)">
        <router-link :to="'/expertOnline/detail/'+item.id">
          <h3 class="item_title">
            <span class="hot" v-if="item.isViewsHot"></span>
            <span class="season" v-if="item.isSeasonHot"></span>
            {{item.question}}
          </h3>
          <div class="item_info">
            <span class="info_img" v-lazy:background-image="item.expert.headImageUrl"></span>
            <div class="info_right">
              <span class="name">{{item.expert.realName}} </span>
              <span class="position">{{item.expert.hospital}}{{item.expert.position}}</span>
            </div>
          </div>
          <p class="item_content">
            {{item.answer}}
          </p>
          <p class="item_read_collection">
            <span class="item_read">{{fomatterNum(item.pageViews)}}妈妈看过</span>
            <span class="item_collection">{{fomatterNum(item.pageCollection)}}收藏</span>
          </p>
        </router-link>
      </div>
    </van-list>
  </div>
</template>

<script>
export default {
  props: {
    fomatterNum: {
      type: Function
    },
    getCookie: {
      type: Function
    }
  },
  data () {
    return {
      expertParams: {
        page: 1,
        size: 25,
        Loading: false, // 是否加载状态
        Finished: false, // 是否加载完成
        Error: false, // 是否加载失败
        finishText: '', // 加载完成文本
      },
      userExpertCollect: []
    }
  },
  mounted () { },
  methods: {
    getExpert () {
      const that = this;
      const userInfo = JSON.parse(localStorage.getItem('userInfo'));
      this.$http.post("/expert/expertCollectionList", {}, { "data": { "crmId": userInfo.crm_id }, "page": this.expertParams.page, "size": this.expertParams.size }, res => {
        this.expertParams.Loading = false;
        if (res.code == "200") {
          that.userExpertCollect = that.userExpertCollect.concat(res.data.content)
          if (that.expertParams.page >= Math.ceil(res.data.totalElements / that.expertParams.size)) {
            this.expertParams.Finished = true;
            this.expertParams.finishText = "——已经到底了哦——";
          } else {
            this.expertParams.page += 1;
          }
          if (this.expertParams.page == 1 && res.data.content.length == 0) {
            this.expertParams.finishText = "";
            this.$emit('isEmpty', true);
            $(".van-tabs__content").css("background", "#fff");
          }
        } else {
          this.expertParams.Loading = false;
          this.expertParams.Error = true
        }
      }, res => {
        this.expertParams.Loading = false;
        this.expertParams.Error = true;
      })
    },
    initFn () {
      this.expertParams.Finished = false;
      this.expertParams.Error = false;
      this.expertParams.Loading = false;
      this.userExpertCollect = [];
      this.expertParams.page = 1;
    },
    gioClick () {
      gio('track', 'QAClick', { 'QATitle_var': item.question, 'QALabel_var': item.tagNames, "page_var": "收藏夹" });
    }
  }
}
</script>

<style lang="less" scoped>
.list_item_expert{
  .list_wrap{
    background: #FFFFFF;
    .item_title{
      font-size: @indexFontSize15;
      font-weight:500;
      color:@expertFontColor51;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      margin-bottom: 14px;
      span{
        width: 27px;
        height: 14px;
        margin-right: 5px;
        display: inline-block;
      }
      span.hot{
        background: url(./../../../assets/images/icon/hot.png) no-repeat center center;
        background-size: 100% 14px;
      }
      span.season{
        background: url(./../../../assets/images/icon/season.png) no-repeat center center;
        background-size: 100% 14px;
      }
    }
    .item_info{
      overflow: hidden;
      margin-bottom: 10px;
      .info_img{
        width: 40px;
        height: 40px;
        border-radius: 50%;
        background: #eee;
        display: inline-block;
        margin-right: 3px;
        background-position: center center;
        background-repeat: no-repeat;
        background-size: cover;
        float: left;
        img{
          width: 100%;
          height: 100%;
        }
      }
      .info_right{
        width: 85%;
        float: left;
        font-size:@indexFontSize12;
        line-height: 18px;
        margin-top: 2px;
        .name{
          width: 100%;
          color: #333333;
          overflow: hidden;
          text-overflow:ellipsis;
          white-space: nowrap;
          display: inline-block;
        }
        .position{
          width: 100%;
          color: #999999;
          overflow: hidden;
          text-overflow:ellipsis;
          white-space: nowrap;
          display: inline-block;
        }
      }
    }
    .item_content{
      height: 66px;
      font-size:@indexFontSize14;
      font-weight:400;
      color:@expertFontColor102;
      line-height:22px;
      margin-bottom: 12px;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }
    .item_read_collection{
      text-align: right;
      font-size:@indexFontSize12;
      font-weight:400;
      color:@expertFontColor153;
      line-height:12px;
      .item_read{
        padding-right: 5px;
      }
    }
    /deep/.van-list__loading{
      background: @expertFontColor255;
    }
    /deep/.van-list__finished-text{
      background: @expertFontColor255;
    }
    /deep/.van-list__placeholder{
      background: @expertFontColor255;
    }
    /deep/.van-list__error-text{
      background: @expertFontColor255;
    }
  }
  .list_empty{
    padding: 16px 12px;
    border-bottom: 1px solid @expertBorderColor242;
  }
}
</style>